import React from 'react';
import { ArrowUp } from 'lucide-react';

const SendButton = ({
  onClick,
  disabled,
  canSend
}) => {
  const isDisabled = disabled || !canSend;

  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      className={`
        h-11 w-11
        rounded-full
        flex
        items-center
        justify-center
        transition-all
        duration-200
        ${isDisabled
          ? 'cursor-not-allowed'
          : 'bg-black dark:bg-white text-white dark:text-black hover:bg-gray-800 dark:hover:bg-gray-200'
        }
      `}
      style={isDisabled ? {
        backgroundColor: 'var(--color-send-button-disabled)',
        color: 'var(--color-text-muted)'
      } : undefined}
    >
      <ArrowUp size={22} strokeWidth={2.5} />
    </button>
  );
};

export default SendButton;
